var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCssWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 362.734,
    height: 512,
    viewBox: "0 0 362.734 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "css-white",
    transform: "translate(-193.633 -276.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3013",
    transform: "translate(119 276.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon2989",
    d: "M437.367,100.62l-33.046,370.2L255.778,512,107.644,470.877,74.633,100.62Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2991",
    d: "M376.03,447.246l28.24-316.352H256V480.523Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2993",
    d: "M150.31,268.217l4.07,45.41H256v-45.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2995",
    d: "M256,176.3H142.132l4.128,45.411H256Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2997",
    d: "M256,433.4V386.153l-.2.053L205.227,372.55l-3.233-36.217H156.409l6.362,71.3,93.02,25.823Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2999",
    d: "M160,0h55V23H183V46h32V69H160Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3001",
    d: "M226,0h55V20H249v4h32V70H226V49h32V45H226Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3003",
    d: "M292,0h55V20H315v4h32V70H292V49h32V45H292Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon3005",
    d: "M311.761,313.627l-5.271,58.894-50.647,13.67v47.244l93.094-25.8.683-7.672,10.671-119.551,1.108-12.194,8.2-91.912H255.843v45.411h63.988l-4.132,46.5H255.843v45.41Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssWhite);
export default __webpack_public_path__ + "static/media/css-white.5b51d3f5203edee6e821d2a9158803a3.svg";
export { ForwardRef as ReactComponent };